/**
 * Util icons to get the correct URI of the icons
 * URI will change when build to something like /img/symbols.badkf8574i.svg
 */

import utilitySprite from "@/assets/icons/utility-sprite/svg/symbols.svg";
import standardSprite from "@/assets/icons/standard-sprite/svg/symbols.svg";
import customSprite from "@/assets/icons/custom-sprite/svg/symbols.svg";
import combinedSprite from "@/assets/icons/SLDS-icons.svg";
import appSprite from "@/assets/icons/app-icons.svg";

export default (function iconsUri() {
  return {
    utilitySpriteUri: utilitySprite,
    standardSpriteUri: standardSprite,
    customSpriteUri: customSprite,
    combinedSpiteUri: combinedSprite,
    appSpriteUri: appSprite,
    getUtilityUrl: function(iconName) {
      return this.utilitySpriteUri + "#" + iconName;
    },
    getStandardUrl: function(iconName) {
      return this.standardSpriteUri + "#" + iconName;
    },
    getCustomUrl: function(iconName) {
      return this.customSpriteUri + "#" + iconName;
    },
    getSLDSIconUrlForPreview: function() {
      return this.combinedSpiteUri;
    },
    getAppIconUrlForPreview: function() {
      return this.appSpriteUri;
    },
    getUtilityIconByType: function(type) {
      type = type.toLowerCase();
      let iconName = "";
      if (type === "string") {
        iconName = "text";
      } else if (type === "number" || type === "integer") {
        iconName = "number_input";
      } else if (type === "date") {
        iconName = "date_input";
      } else if (type === "datetime") {
        iconName = "date_time";
      } else if (type === "bool" || type === "boolean") {
        iconName = "check";
      } else {
        return;
      }
      return this.getUtilityUrl(iconName);
    }
  };
})();

